module.exports = __webpack_public_path__ + "img/ma240.a43b45ab.png";